//UUID Library to work with UUIDs from desktop, WIP.

//Hex mapping
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
   byteToHex.push((i + 0x100).toString(16).slice(1));
}

export function ECLUnsafeStringifyUUID(arr, offset = 0) {
   if (arr?.length !== 16) {
      return null;
   }
   // Note: Be careful editing this code!  It's been tuned for performance
   // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
   // Michael Note: I wasn't careful at all editing this code.
   return (
      byteToHex[arr[offset + 3]] +
      byteToHex[arr[offset + 2]] +
      byteToHex[arr[offset + 1]] +
      byteToHex[arr[offset + 0]] +
      "-" +
      byteToHex[arr[offset + 5]] +
      byteToHex[arr[offset + 4]] +
      "-" +
      byteToHex[arr[offset + 7]] +
      byteToHex[arr[offset + 6]] +
      "-" +
      byteToHex[arr[offset + 8]] +
      byteToHex[arr[offset + 9]] +
      "-" +
      byteToHex[arr[offset + 10]] +
      byteToHex[arr[offset + 11]] +
      byteToHex[arr[offset + 12]] +
      byteToHex[arr[offset + 13]] +
      byteToHex[arr[offset + 14]] +
      byteToHex[arr[offset + 15]]
   );
}

// https://www.npmjs.com/package/id128 in /id128/src/coder/crockford32.js
//It works, refuse to look gift horse in mouth
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const MAX_QUINTET = 0b11111;

//CHAR_TO_QUINTET is assigned a value but never used
// const CHAR_TO_QUINTET = Array.from(ALPHABET).reduce(
//    (acc, chr, idx) => ((acc[chr] = acc[chr.toLowerCase()] = idx), acc),
//    {
//       I: ALPHABET.indexOf("1"),
//       i: ALPHABET.indexOf("1"),
//       L: ALPHABET.indexOf("1"),
//       l: ALPHABET.indexOf("1"),
//       O: ALPHABET.indexOf("0"),
//       o: ALPHABET.indexOf("0"),
//       U: ALPHABET.indexOf("V"),
//       u: ALPHABET.indexOf("V"),
//    },
// );
const QUINTET_TO_CHAR = Array.from(ALPHABET);

function _quintetToChar(quintet) {
   return QUINTET_TO_CHAR[quintet & MAX_QUINTET];
}

export function ECLUnsafeStringifyULID(bytes) {
   if (bytes?.length !== 16) {
      return null;
   }
   //Note: unrolled for performance
   let quintets = [
      bytes[0] >> 5,
      bytes[0],

      bytes[1] >> 3,
      (bytes[1] << 2) | (bytes[2] >> 6),
      bytes[2] >> 1,
      (bytes[2] << 4) | (bytes[3] >> 4),
      (bytes[3] << 1) | (bytes[4] >> 7),
      bytes[4] >> 2,
      (bytes[4] << 3) | (bytes[5] >> 5),
      bytes[5],

      bytes[6] >> 3,
      (bytes[6] << 2) | (bytes[7] >> 6),
      bytes[7] >> 1,
      (bytes[7] << 4) | (bytes[8] >> 4),
      (bytes[8] << 1) | (bytes[9] >> 7),
      bytes[9] >> 2,
      (bytes[9] << 3) | (bytes[10] >> 5),
      bytes[10],

      bytes[11] >> 3,
      (bytes[11] << 2) | (bytes[12] >> 6),
      bytes[12] >> 1,
      (bytes[12] << 4) | (bytes[13] >> 4),
      (bytes[13] << 1) | (bytes[14] >> 7),
      bytes[14] >> 2,
      (bytes[14] << 3) | (bytes[15] >> 5),
      bytes[15],
   ];

   //Note: Massive performance losses occured when
   // using the more legible Array.map and Array.join
   let encoding = "";
   for (let idx = 0, end = quintets.length; idx < end; ++idx) {
      encoding += _quintetToChar(quintets[idx]);
   }
   return encoding;
}
